import cmsStyles from '@/cmsComponents/style.module.scss';
import cx from 'classnames';
import React from 'react';
import ReactMarkdown from 'react-markdown';

import MarkdownRenderer from 'components/CMS/MarkdownRenderer';

import styles from './style.module.scss';

export const MarkdownContent = ({ source }) => {
  return (
    <ReactMarkdown
      source={source}
      renderers={MarkdownRenderer}
      className={cx(styles.markdown, cmsStyles.markdownContent)}
      escapeHtml={false}
    />
  );
};
